import { AppSku } from '@polaris-customerweb/sharedcomponents.core';
import { once } from 'lodash-es';
import { isAppSku } from '../models/app-sku.type-guard';

export const appSkuFactory = once((document: Document): AppSku => {
    const dataset = document.querySelector('html')?.dataset;

    const appSku =
        dataset?.plc?.toUpperCase() || dataset?.sku?.toUpperCase() || '';
    if (!isAppSku(appSku)) {
        console.error(
            'html[data.sku] is unexpected value or missing, defaulting to ORV'
        );
        return 'ORV';
    } else if (appSku === 'RDC') {
        return 'ORV';
    } else {
        return appSku as AppSku;
    }
});
